<template>
  <v-sheet class="about pt-14" color="transparent">
    <v-container>
      <v-row
        justify="center"
        align="center"
        class="flex-column-reverse flex-sm-row"
      >
        <v-col class="pa-0 px-10 px-sm-0 mt-6 mt-sm-0" cols="12" lg="4" sm="4"
          ><img class="d-block" src="/img/algoamais/about.png" width="100%"
        /></v-col>
        <v-col cols="12" lg="5" sm="6">
          <div class="about-caption PFDinDisplayPro px-5 px-sm-0">
            A Canaã Norte Resíduos é feita de ciclos e todos eles nos levam a
            entregar sempre
            <span class="font-weight-bold accent--text text--darken-1"
              >Algo a mais</span
            >
            para nossos colaboradores e, principalmente, para você amigo
            cliente. Uma nova campanha, para um novo ano que já está batendo na
            porta. Entregar algo a mais é fazer a diferença na vida do próximo,
            a qualquer hora do dia!
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.about {
  &-caption {
    font-style: italic;
    font-weight: 400;
    font-size: 24px;
    line-height: 29px;
    text-align: center;
    color: #757575;
    @media (max-width: 1200px) {
      font-size: 20px;
      line-height: 22px;
    }
    @media (max-width: 960px) {
      font-size: 18px;
      line-height: 21.6px;
    }
  }
}
</style>
